import React from 'react'
import { Link } from 'react-router-dom'
function Header() {
    return (
        <section className='navsec fix-header'>
            <div className='container fullcontainer'>
                <div className='row'>
                    <div className='col-xl-12 logo-nav'>
                        <div className="LogoR">
                            <a href='/'>
                                <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/logoM.png" className="img-fluid" alt="St Mary Bokaro" />
                            </a>
                        </div>
                        <div class="header">
                            <nav>
                                <a id="resp-menu" class="responsive-menu" href="#"><i class="bi bi-menu-down"></i> Menu</a>
                                <ul class="menu">
                                    <li><Link to={'/'}>Home</Link></li>
                                    <li><a href=""> About Us<i class="bi bi-caret-down-fill"></i></a>
                                        <ul class="sub-menu">
                                            <li><Link to="/AboutUs">About Us</Link></li>
                                            <li><Link to="/Campus">Our Campus</Link></li>
                                            <li><Link to="/OurMotto">Our Motto</Link></li>
                                            <li><Link to="/MissionVision">Mission & Vision</Link></li>
                                            <li><Link to="/PrincipalsMessage">Principal's Message</Link></li>
                                            <li><Link to="/SchoolPhilosophy">School Philosophy</Link></li>
                                            <li><Link to="/StaffDetails">Staff Details</Link></li>
                                        </ul>
                                    </li>
                                    <li><Link to={'#'}>Creative Persuits</Link></li>
                                    <li><a href=""> Curriculum<i class="bi bi-caret-down-fill"></i></a>
                                        <ul class="sub-menu">
                                            <li><Link to="/TeachingSubjects">Teaching Subjects</Link></li>
                                            <li><Link to="/TeachingPedagogy ">Teaching Pedagogy </Link></li>
                                        </ul>
                                    </li>
                                    <li>
                                        <div className="logo">
                                            <div className='logotitle'>
                                                <a href='/'>
                                                    <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/Nlogo.png" className="img-fluid mx-auto d-block" alt="St Mary Bokaro" />
                                                </a>
                                                <h3>St. MARY'S NURSERY SCHOOL</h3>
                                                <h6>Bokaro (SMNS)</h6>
                                            </div>

                                        </div>
                                    </li>
                                    <li><a href=""> Admission<i class="bi bi-caret-down-fill"></i></a>
                                        <ul class="sub-menu">
                                            <li><Link to="/AdmissionDetails">Admission Details</Link></li>
                                            <li><Link to="/Booklist">Booklist</Link></li>
                                            <li><Link to="/FeeStructure">Fee Structure </Link></li>
                                        </ul>
                                    </li>
                                    <li><Link to="/Gallery">Gallery</Link></li>
                                    <li><Link to="/Contact">Contact</Link></li>
                                    <li>
                                        <div className='joinus'>
                                            <Link to="/Contact">JOIN US</Link>
                                        </div>
                                    </li>
                                    {/* 
                                    <li><Link to="/Activities">Activities</Link></li>                          
                                    <li><a href="#">Our Campus<i class="bi bi-caret-down-fill"></i></a>
                                        <ul class="sub-menu">
                                            <li><Link to="#">Infrastructure</Link></li>
                                            <li><a href="#" id="admissions"> Facilities <i class="bi bi-caret-right-fill"></i></a>
                                                <ul class="sub-menu">
                                                    <li><Link to="#">Transport </Link></li>
                                                    <li><Link to="/our-campus/facilities/security-and-safety" >Security & Safety</Link></li>                                              
                                                </ul>
                                            </li>
                                        </ul>
                                    </li> 
                                    */}
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Header